import React from "react"

import { Skeleton } from "@coval/ui/skeleton"

export const RunResultsTableSkeleton: React.FC<{
  rowCount?: number
  columnCount?: number
}> = ({ rowCount = 5, columnCount = 6 }) => (
  <div className="p-6">
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-coval-border">
            {Array.from({ length: columnCount }).map((_, i) => (
              <th key={i} className="px-4 py-3 text-left">
                <Skeleton className="h-4 w-20" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rowCount }).map((_, rowIndex) => (
            <tr key={rowIndex} className="border-b border-coval-border">
              {Array.from({ length: columnCount }).map((_, colIndex) => (
                <td key={colIndex} className="px-4 py-3">
                  <Skeleton
                    className={`h-4 ${colIndex === 0 ? "w-8" : colIndex === 1 ? "w-32" : "w-16"}`}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)
